import React from 'react';
import {
    Switch,
    message
} from 'antd';
import { FaCheck, FaTimes } from "react-icons/fa";
import { useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';


function CheckSwitch({ isCheck, attItemsId }) {
    const { id } = useParams();
    const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            // console.log(data);
            axios
                .put(`/api/attendance/attendanceCheck/${attItemsId}`, data)
                .then(res => {
                    messageApi.open({
                        type: 'success',
                        content: 'Create successfully',
                        duration: 1,
                        onClose: () => {
                            queryClient.invalidateQueries([`/api/attendance/attendanceStudents/${id}`]);
                        }
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Create failed!',
                    });
                })
        },
    });

    const onChange = (checked) => {
        // console.log(checked);
        mutate({ is_attent: checked });
    };

    // console.log(isCheck);
    return (
        <div>
            {contextHolder}
            <Switch
                defaultChecked={isCheck}
                checkedChildren={<FaCheck />}
                unCheckedChildren={<FaTimes />}
                onChange={onChange}
                disabled={isLoading}
            />
        </div>
    )
}

export default CheckSwitch